import parse from "html-react-parser";
import React from "react";
import { isAndroid, isBrowser, isIOS } from "react-device-detect";
import { resources } from "../../resources/strings";
import "./styles.scss";
import "./v2-styles.scss";
import PageTitle from "../../components/PageTitle";
import { WorkerRegistrationStore } from "../../stores/WorkerRegistrationStore";
import { ClientTrackingNames } from "../../models/ClientTracking";
import Slide from "../../AnimationTransitions/SlideInTransition";
import { observer } from "mobx-react";
import { format } from "../../utils/formatStrings";
import { Link } from "react-router-dom";
import { Button } from "@material-ui/core";
import { ConfigService } from "../../services/ConfigService";
import QRCode from "qrcode.react";

function PlatformLogo() {
  const { constants } = ConfigService.getInstance().values;

  return (
    <img
      className="logo"
      src={constants.PARTNER_LOGO_URL}
      alt={resources.brandLogoAltText}
    />
  );
}

function AppStoreLink({ onClick }: { onClick: () => void }) {
  const { constants } = ConfigService.getInstance().values;

  return (
    <div className="link-block" onClick={onClick}>
      <img
        src={constants.APP_STORE_IOS_IMAGE_URL}
        alt={resources.appStoreIOSImageLinkAltText}
      />
    </div>
  );
}

function PlayStoreLink({ onClick }: { onClick: () => void }) {
  const { constants } = ConfigService.getInstance().values;

  return (
    <div className="link-block" onClick={onClick}>
      <img
        src={constants.APP_STORE_ANDROID_IMAGE_URL}
        alt={resources.appStoreAndroidImageLinkAltText}
      />
    </div>
  );
}

function WorkerDesktopLink({ onClick }: { onClick: () => void }) {
  const { constants } = ConfigService.getInstance().values;

  return (
    <div className="link-block" onClick={onClick}>
      <img
        src={constants.WORKER_DESKTOP_IMAGE_URL}
        alt={resources.workerDesktopImageLinkAltText}
      />
    </div>
  );
}

interface IProps {
  workerRegistrationStore: WorkerRegistrationStore;
}

@observer
class ImmediateDownloadNow extends React.Component<IProps> {
  private strings = resources.immediateDownloadPage;
  private v2Strings = {
    startFindingJobs: resources.startFindingJobs,
    downloadNow: resources.downloadNow,
  };
  private store = this.props.workerRegistrationStore.appDownloadStore;

  componentDidMount() {
    this.props.workerRegistrationStore.showHeader();
    this.props.workerRegistrationStore.hideBackBtn();

    const { features } = ConfigService.getInstance().values;
    if (features.showAppDownloadV2) {
      this.props.workerRegistrationStore.hideHeader();
    }

    this.store.clientTracking.trackRender(
      ClientTrackingNames.DownloadAppRegistration
    );
    this.store.startRedirectTimerAt(0, true);
  }

  private getIOS = () => {
    const logo = "/images/apple-badge.png";

    return (
      <img
        src={logo}
        onClick={() => this.store.iosBannerClicked()}
        className={"logo"}
        alt={"ios download"}
      ></img>
    );
  };

  private getAndroid = () => {
    const logo = "/images/google-badge.png";

    return (
      <img
        src={logo}
        onClick={() => this.store.androidBannerClicked()}
        className={"logo"}
        alt={"android download"}
      ></img>
    );
  };

  private getRedirectMessage() {
    const redirectLabel1 = format(this.strings.redirectLabel1, [
      this.store.redirectTimer,
    ]);
    const redirectLink = (
      <span className="stop-redirect" onClick={this.store.stopRedirectTimer}>
        {this.strings.redirectLabel2}
      </span>
    );

    return (
      <div className="redirect">
        {redirectLabel1}
        {redirectLink}
        {this.strings.redirectLabel3}
      </div>
    );
  }

  get featureList() {
    const configs = ConfigService.getInstance().values;
    const features = configs.features;

    if (!features.showDownloadFeatures) {
      return null;
    }

    return (
      <div className={"featureContainer"}>
        <span className={"featureTitle"}>
          {parse(this.strings.featureTitle)}
        </span>
        {this.strings.featureList.map((feature) => {
          return (
            <div className={"featureItem"}>
              <div className={"featureSubTitle"}>{feature.title}</div>
              <div className={"featureDescription"}>
                {parse(feature.description)}
              </div>
            </div>
          );
        })}
      </div>
    );
  }

  private determineContainer = () => {
    if (isBrowser) {
      return "browser";
    }

    if (!isIOS && !isAndroid) {
      return "device-not-detected";
    } else {
      return "redirecting";
    }
  };

  private getAppsContainer = () => {
    const iosBanner = this.getIOS();
    const androidBanner = this.getAndroid();

    if (isBrowser) {
      return (
        <div>
          <span className={"congratulationsText"}>
            {this.strings.scanBelow}
          </span>
          <div className="apps-container">{this.QRCodeContainer}</div>
          <div>{parse(this.strings.qrDescription)}</div>
          {this.featureList}
        </div>
      );
    }

    if (!isIOS && !isAndroid) {
      return (
        <div>
          <span className={"congratulationsText"}>
            {this.strings.appStoreLinking}
          </span>
          <div className="apps-container">
            {iosBanner}
            {androidBanner}
          </div>
          <p>{this.strings.description}</p>
          <Link className="register-button" to={"/sign-up"}>
            <Button className="button register-button">
              {this.strings.registerButtonLabel}
            </Button>
          </Link>
        </div>
      );
    } else {
      return (
        <div>
          <span className={"congratulationsText"}>
            {this.strings.appStoreAutoLinking}
          </span>
          <div className="apps-container">
            {isIOS && iosBanner}
            {isAndroid && androidBanner}
          </div>
          <span className={"successText"}>
            {this.strings.descriptionDeviceDetected}
          </span>
          {this.store.canRedirect &&
            (isIOS || isAndroid) &&
            this.getRedirectMessage()}
        </div>
      );
    }
  };

  private getTrackingPixel = () => {
    //consider passing in a value here to allow different pixels to be displayed.
    if (!this.props.workerRegistrationStore._talrooPixelDisplay) {
      return null;
    }
    return (
      <img
        src="https://www.jobs2careers.com/conversion2.php?p=6185"
        width="1"
        height="1"
      />
    );
  };

  get QRCodeContainer() {
    if (!isBrowser) {
      return null;
    }
    const paramStore = this.props.workerRegistrationStore.urlParamStore;

    return <QRCode value={paramStore.getQRDownloadingLink(true)} size={200} />;
  }

  private getV2BrowserPage() {
    return (
      <Slide in className="download-now-2">
        <PlatformLogo />
        <h1 className="title">{this.v2Strings.startFindingJobs.heading}</h1>
        {this.v2Strings.startFindingJobs.bodyLines.map((line) => (
          <p key={line} className="body-line">
            {line}
          </p>
        ))}
        <footer className="links">
          <AppStoreLink onClick={() => this.store.iosBannerClicked()} />
          <PlayStoreLink onClick={() => this.store.androidBannerClicked()} />
          <WorkerDesktopLink
            onClick={() => this.store.workerDesktopBannerClicked()}
          />
        </footer>
      </Slide>
    );
  }

  private getV2RedirectPage() {
    return (
      <Slide in className="download-now-2">
        <PlatformLogo />
        <h1 className="title">{this.v2Strings.downloadNow.heading}</h1>
        {isIOS && (
          <p className="body-line">
            {this.v2Strings.downloadNow.redirectedAppStore}
          </p>
        )}
        {isAndroid && (
          <p className="body-line">
            {this.v2Strings.downloadNow.redirectedPlayStore}
          </p>
        )}
        <p className="body-line">{this.v2Strings.downloadNow.appFallback}</p>
        <footer className="links">
          {isIOS && (
            <AppStoreLink onClick={() => this.store.iosBannerClicked()} />
          )}
          {isAndroid && (
            <PlayStoreLink onClick={() => this.store.androidBannerClicked()} />
          )}
        </footer>
      </Slide>
    );
  }

  render() {
    const appsContainer = this.getAppsContainer();

    const trackingPixel = this.getTrackingPixel();

    const { features } = ConfigService.getInstance().values;

    if (features.showAppDownloadV2) {
      switch (this.determineContainer()) {
        case "browser":
        case "device-not-detected":
          return (
            <React.Fragment>
              {this.getV2BrowserPage()}
              {trackingPixel}
            </React.Fragment>
          );
        case "redirecting":
          return (
            <React.Fragment>
              {this.getV2RedirectPage()}
              {trackingPixel}
            </React.Fragment>
          );
      }
    }

    return (
      <Slide in className="standard download-now">
        <PageTitle text={this.strings.downloadNowLabel} />

        <div className="apps-container-wrapper">
          {appsContainer}
          {trackingPixel}
        </div>
      </Slide>
    );
  }
}

export default ImmediateDownloadNow;
